var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "OnHold",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-on-hold","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <rect width="18" height="101.7" x="86.6" y="78"/>
  <rect width="18" height="101.7" x="144.5" y="78"/>
  <path d="M124.5 249.5C55.9 249.5 0 193.6 0 125S55.9.5 124.5.5 249 56.4 249 125s-55.8 124.5-124.5 124.5zm0-240C60.8 9.5 9 61.3 9 125s51.8 115.5 115.5 115.5S240 188.7 240 125 188.2 9.5 124.5 9.5z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/on-hold.svg